import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getFormMeta, getFormSyncErrors} from "redux-form";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {PASSWORD_VALIDATION_DIGIT, PASSWORD_VALIDATION_DISALLOWED, PASSWORD_VALIDATION_LENGTH, PASSWORD_VALIDATION_MATCHING, PASSWORD_VALIDATION_NODASHBEGIN, PASSWORD_VALIDATION_SPECIAL, PASSWORD_VALIDATION_UPPER_LOWER} from "../../constants/PasswordStrength";
import {faTimes} from "@fortawesome/pro-light-svg-icons/faTimes";
import {faCheck} from "@fortawesome/pro-light-svg-icons/faCheck";
import {delve} from "../../util/util";

const ErrorIcon = (props) => {
    return <FontAwesomeIcon fixedWidth={true} className={"error"} icon={faTimes}/>
}

const CorrectIcon = (props) => {
    return <FontAwesomeIcon fixedWidth={true} className={"correct"} icon={faCheck}/>
}

class PasswordStrengthTooltip extends Component {
    render() {
        const passwordErrors = this.props.passwordErrors["projectPasswordErrors"] || {};

        if (
            !(
                delve(this.props.registeredFormFields, "projectPassword.active")
                ||
                delve(this.props.registeredFormFields, "projectPasswordRepeat.active")
            )
            ) {
            // only render if one field is active or if there are password error
            return null;
        }

        return (
            <div className={"password-strength-tooltip"}>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_LENGTH] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>min. 12 Zeichen</span>
                </div>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_UPPER_LOWER] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>min. je 1 Klein- und Großbuchstabe (keine Umlaute)</span>
                </div>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_DIGIT] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>min. 1 Ziffer</span>
                </div>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_SPECIAL] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>min. 1 Sonderzeichen aus $ ! # * + , - . ; _ : /</span>
                </div>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_DISALLOWED] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>kein unerlaubtes Zeichen</span>
                </div>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_NODASHBEGIN] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>kein Bindestrich am Anfang</span>
                </div>
                <div className={"password-strength-tooltip__group"}>
                    {passwordErrors[PASSWORD_VALIDATION_MATCHING] ? <ErrorIcon/> : <CorrectIcon/>}
                    <span>Passwörter stimmen überein</span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    return {
        passwordErrors: getFormSyncErrors(props.formIdentifier)(state),
        registeredFormFields: getFormMeta(props.formIdentifier)(state)
    };
}

PasswordStrengthTooltip.propTypes = {
    formIdentifier: PropTypes.string.isRequired,
    registeredFormFields: PropTypes.any,
}

export default connect(
    mapStateToProps,
)(PasswordStrengthTooltip);



/** WEBPACK FOOTER **
 ** ./src/components/forms/PasswordStrengthTooltip.js
 **/